export class UpdateCorporateTirage
{
    corporateTirageId:number;
    montant:number;
    dateTirage:String;
    echeance:number;
}